export default __webpack_public_path__ + "static/media/general-info-primary-icon.4332478a.svg";